<div class="app-container">
  <app-header />
  <main class="main-content">
    <router-outlet />
  </main>
  <app-footer />
</div>
<app-toast-container />
